module.exports = __webpack_public_path__ + "static/media/Knockout.52f85812.woff2";